<template>
  <div>
    <div v-for="(item, index) in dd"
         :key="keyForList[index]">
      <div>
        <div style="float: left; margin: 6px 10px 0 0"
             v-if="!disabled">
          <el-button type="danger"
                     icon="el-icon-delete"
                     size="mini"
                     :disabled="disabled"
                     @click="remove(index)"
                     circle></el-button>
        </div>
        <div style="width: 80%; float: left">
          <item-content :item="fields[0]"
                        :value="item"
                        :disabled="disabled"
                        @input="onChange"
                        :id="index + ''" />
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <div style="clear: both">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 size="mini"
                 v-if="!disabled"
                 :disabled="disabled"
                 @click="addRow"
                 plain>增加一项</el-button>
    </div>
  </div>
</template>
<script>
import ItemContent from './Content';
import { isArray } from 'lodash';

export default {
  name: "ProductItemList",
  components: {
    ItemContent
  },
  computed: {
    fields() {
      let f = []
      for (let i in this.item.type) {
        let v = {
          type: [this.item.type[i]],
        }
        f.push(v)
      }
      return f
    },
    dd() {
      return this.value || []
    }
  },
  data() {
    return {
      keyForList: []
    }
  },
  watch: {
    value() {
      for (let i = 0; i < this.value.length - this.keyForList; i++) {
        this.keyForList.push(Math.round(Math.random() * 100000000))
      }
    }
  },
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    item: {
      type: Object,
      default: () => { return {} }
    },
    id: {
      type: String,
      default: () => ''
    },
    disabled: Boolean
  },
  methods: {
    onChange(v, id) {
      let n = JSON.parse(JSON.stringify(this.value))
      if (!isArray(n)) {
        n = []
      }

      n[id] = v
      this.$emit('input', n, this.id)
    },
    addRow() {
      let n = JSON.parse(JSON.stringify(this.value))
      n.push(null)

      this.keyForList.push(Math.round(Math.random() * 100000000))
      this.$emit('input', n, this.id)
    },
    remove(index) {
      this.keyForList.splice(index, 1)
      let n = JSON.parse(JSON.stringify(this.value))

      n.splice(index, 1)
      this.$emit('input', n, this.id)
    }
  }
}
</script>
